<template>
  <div>
    <div class="main-content card" v-if="loader === 100">
      <div class="row p-1">
        <div class="col-md-1">
          <label>Prefixo</label>
          <input type="text" class="form-control" v-model="pesquisa.prefixo" />
        </div>
        <div class="col-md-1">
          <label>Senha</label>
          <input type="text" class="form-control" v-model="pesquisa.senha" />
        </div>
        <div class="col-md-2">
          <label>Pessoa</label>
          <input
            type="text"
            class="form-control"
            v-model="filtros.pessoa"
            placeholder="Filtrar pessoa..."
          />
        </div>
        <div class="col-md-2">
          <label>Setor</label>
          <v-select
            v-model="filtros.setorObj"
            :options="setores"
            label="nome"
            :reduce="(s) => s.nome"
            placeholder="Filtrar setor..."
            @input="onSetorChange"
          ></v-select>
        </div>
        <div class="col-md-2">
          <label>Status</label>
          <select class="form-control" v-model="filtros.status">
            <option value="">Todos</option>
            <option value="0">Ausente</option>
            <option value="1">Em fila</option>
            <option value="2">Em atendimento</option>
            <option value="3">Atendido</option>
            <option value="4">Evadido</option>
            <option value="5">Cancelado</option>
            <option value="fechamento">Encerrado via fechamento de dia</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Data inicial</label>
          <input
            type="date"
            class="form-control"
            v-model="pesquisa.data_inicio"
            :max="pesquisa.data_fim || hoje"
          />
        </div>
        <div class="col-md-2">
          <label>Data final</label>
          <input
            type="date"
            class="form-control"
            v-model="pesquisa.data_fim"
            :min="pesquisa.data_inicio"
            :max="hoje"
            :disabled="!pesquisa.data_inicio"
            :title="
              !pesquisa.data_inicio
                ? 'Preencha a Data Inicial primeiro'
                : ''
            "
          />
        </div>
        <div class="col-md-3 mt-1">
          <label>Operador</label>
          <v-select
            v-model="filtros.operadorId"
            :options="usuarios"
            label="name"
            :reduce="(u) => u.id"
            placeholder="Filtrar operador..."
          ></v-select>
        </div>
        <div class="col-md-3 mt-1">
          <label>Classificação de Risco</label>
          <v-select
            v-model="filtros.grupoPrioritario"
            :options="classificacoes"
            label="nome"
            :reduce="(c) => c.id"
            placeholder="Filtrar grupo..."
          ></v-select>
        </div>
        <div class="col-md-3 mt-1">
          <label>Prioridade</label>
          <v-select
            v-model="filtros.prioridadeFilter"
            :options="prioridades"
            label="nome"
            :reduce="(p) => p.id"
            placeholder="Filtrar prioridade..."
          ></v-select>
        </div>
        <div class="col-md-12 mt-2">
          <div class="alert alert-info py-1 mb-0" style="font-size: 0.95rem">
            <i class="fas fa-info-circle ml-1"></i>
            O <strong>PDF</strong> exporta apenas a página atual. O
            <strong>Excel</strong> exporta todos os registros do período (limite
            de 30 dias) e é processado em segundo plano.
          </div>
        </div>
        <div class="col-md-12 d-flex mt-2 pl-1">
          <button class="btn btn-primary mr-2" @click="getPasswords()">
            <i class="fas fa-search"></i> Pesquisar
          </button>
          <button
            class="btn btn-danger mr-2"
            :disabled="!groupedPasswords.length"
            @click="getPdf()"
          >
            <i class="fas fa-file-pdf"></i> PDF
          </button>
          <button
            class="btn btn-success"
            :disabled="!groupedPasswords.length || excelProcessing"
            @click="getExcel()"
          >
            <i v-if="!excelProcessing" class="fas fa-file-excel"></i>
            <i v-else class="fas fa-spinner fa-spin"></i>
            Excel
          </button>
        </div>

        <div class="col-12 p-1" v-if="excelProcessing">
          <div class="alert alert-info mb-0 d-flex align-items-center">
            <i class="fas fa-spinner fa-spin mr-2"></i>
            <span>
              <strong>Gerando arquivo(s) Excel...</strong><br />
              <small
                >Seu arquivo está sendo processado em background. Para períodos
                longos, será gerado um arquivo ZIP com múltiplos Excels. Aguarde
                alguns instantes...</small
              >
            </span>
          </div>
        </div>
        <div class="col-12 p-1" v-if="excelReady">
          <div
            class="alert alert-success mb-0 d-flex align-items-center justify-content-between"
          >
            <span>
              <i class="fas fa-check-circle mr-2"></i>
              <strong>Arquivo pronto para download!</strong>
            </span>
            <button
              class="btn btn-success btn-sm"
              @click="downloadExcel(excelFilename)"
            >
              <i class="fas fa-download mr-1"></i> Baixar Arquivo
            </button>
          </div>
        </div>

        <div class="col-12 p-1">
          <hr />

          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="font-weight-bold text-dark" style="font-size: 0.95rem">
              {{ groupedPasswords.length }} senha{{
                groupedPasswords.length !== 1 ? "s" : ""
              }}
            </span>
            <button
              v-if="groupedPasswords.length"
              class="btn btn-sm btn-outline-secondary"
              @click="toggleExpandAll()"
            >
              {{ expandAllState ? "Recolher tudo" : "Expandir tudo" }}
            </button>
          </div>

          <div v-if="groupedPasswords.length === 0" class="empty-state">
            <div class="empty-state-content">
              <i class="fas fa-search fa-3x text-muted mb-3"></i>
              <h5 class="text-muted">Nenhum registro encontrado</h5>
              <p class="text-muted mb-0">
                Selecione um período e clique em pesquisar.
              </p>
            </div>
          </div>

          <div
            v-for="grupo in groupedPasswords"
            :key="grupo.atendimento.id"
            class="senha-card mb-2"
          >
            <div
              class="senha-card-header"
              @click="toggleExpand(grupo.atendimento.id)"
            >
              <div class="header-left">
                <span
                  class="badge badge-pill mr-1"
                  :style="getSenhaBadgeStyle(grupo)"
                >
                  {{ grupo.atendimento.prefixo }}{{ grupo.atendimento.senha }}
                </span>
                <span class="badge badge-pill badge-dark mr-2">
                  {{
                    grupo.atendimento.botao ? grupo.atendimento.botao.nome : "—"
                  }}
                </span>
                <strong
                  class="header-nome"
                  :title="
                    grupo.atendimento.pessoa
                      ? grupo.atendimento.pessoa.nome
                      : 'Não informado'
                  "
                >
                  {{
                    grupo.atendimento.pessoa
                      ? grupo.atendimento.pessoa.nome
                      : "Não informado"
                  }}
                </strong>
              </div>
              <div class="header-right">
                <span class="card-data-entrada">
                  <i class="fas fa-clock mr-1"></i
                  >{{ grupo.etapas[0].data_entrada_f }}
                </span>
                <span class="badge badge-pill badge-light card-etapas-badge">
                  {{ grupo.etapas.length }} etapa{{
                    grupo.etapas.length !== 1 ? "s" : ""
                  }}
                </span>
                <span class="badge badge-pill badge-success">
                  <i class="fas fa-hourglass-half mr-1"></i
                  >{{ calcTotalTime(grupo.etapas) }}
                </span>
                <span
                  :class="
                    'badge badge-pill badge-' + getStatusBadgeColor(grupo)
                  "
                >
                  {{ getStatusText(grupo) }}
                </span>
                <i
                  class="fas chevron-icon"
                  :class="
                    isExpanded(grupo.atendimento.id)
                      ? 'fa-chevron-up'
                      : 'fa-chevron-down'
                  "
                ></i>
              </div>
            </div>

            <div
              v-if="isExpanded(grupo.atendimento.id)"
              class="senha-card-body"
            >
              <table class="table table-sm mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Setor</th>
                    <th>Local</th>
                    <th>Classificação de Risco</th>
                    <th>Prioridade</th>
                    <th>Entrada</th>
                    <th>Espera</th>
                    <th>Última Chamada</th>
                    <th>Chamadas</th>
                    <th>Saída</th>
                    <th>Operador</th>
                    <th>Status</th>
                    <th>Tempo Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(etapa, idx) in grupo.etapas" :key="etapa.id">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ etapa.setor ? etapa.setor.nome : "—" }}</td>
                    <td>{{ etapa.local ? etapa.local.nome : "—" }}</td>
                    <td>
                      <span
                        v-if="etapa.classificacao"
                        class="badge badge-pill"
                        :style="{
                          backgroundColor: etapa.classificacao.cor,
                          color: getContrastColor(etapa.classificacao.cor),
                        }"
                        >{{ etapa.classificacao.nome }}</span
                      >
                      <span v-else>—</span>
                    </td>
                    <td>
                      {{
                        etapa.prioridade ? etapa.prioridade.nome || "—" : "—"
                      }}
                    </td>
                    <td>{{ etapa.data_entrada_f }}</td>
                    <td>{{ etapa.tempo_espera || "—" }}</td>
                    <td>
                      {{
                        etapa.data_ultima_chamada_f &&
                        etapa.data_ultima_chamada_f !== false
                          ? etapa.data_ultima_chamada_f
                          : "Não chamado"
                      }}
                    </td>
                    <td>{{ etapa.vezes_chamado || 0 }}x</td>
                    <td>{{ etapa.data_fim_f || "Não finalizado" }}</td>
                    <td>{{ etapa.user ? etapa.user.name : "—" }}</td>
                    <td>
                      <span :class="'badge badge-' + resolveEtapaColor(etapa)">
                        {{ resolveEtapaText(etapa) }}
                      </span>
                    </td>
                    <td>{{ etapa.tempo_total || "—" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            v-if="total > 0"
            class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
          >
            <pagination
              :records="total"
              :options="options"
              :per-page="15"
              @paginate="getPasswords"
            ></pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";

export default {
  name: "imageUpload",
  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
      configuracao: [],
      loader: 0,
      passwords: [],
      expandedItems: [],
      expandAllState: false,
      excelProcessing: false,
      excelReady: false,
      excelFilename: null,
      excelCheckInterval: null,
      excelTimeout: null,
      hoje: new Date().toISOString().split("T")[0],
      pesquisa: {
        prefixo: "",
        senha: "",
        data_inicio: "",
        data_fim: "",
      },
      filtros: {
        pessoa: "",
        demanda: "",
        setor: "",
        setorObj: null,
        local: "",
        status: "",
        operadorId: null,
        grupoPrioritario: null,
        prioridadeFilter: null,
      },
      setores: [],
      classificacoes: [],
      usuarios: [],
      prioridades: [],
    };
  },
  computed: {
    alertaPeriodoLongo() {
      if (!this.pesquisa.data_inicio || !this.pesquisa.data_fim) return false;
      const diff = Math.abs(
        new Date(this.pesquisa.data_fim) - new Date(this.pesquisa.data_inicio)
      );
      return Math.ceil(diff / (1000 * 60 * 60 * 24)) > 30;
    },
    groupedPasswords() {
      // Usa Map para preservar a ordem de inserção (Object com chaves inteiras
      // ordena numericamente, ignorando o FIELD() do backend)
      const map = new Map();
      this.passwords.forEach((setor) => {
        if (!setor.atendimento) return;
        const aid = setor.atendimento.id;
        if (!map.has(aid)) {
          map.set(aid, { atendimento: setor.atendimento, etapas: [] });
        }
        map.get(aid).etapas.push(setor);
      });
      return Array.from(map.values());
    },
  },
  watch: {
    "filtros.pessoa": function () {
      this.debounceSearch();
    },
    "filtros.demanda": function () {
      this.debounceSearch();
    },
    "filtros.setor": function () {
      this.debounceSearch();
    },
    "filtros.local": function () {
      this.debounceSearch();
    },
    "filtros.status": function () {
      this.getPasswords(1);
    },
  },
  methods: {
    debounceSearch: function () {
      const self = this;
      clearTimeout(self._debounceTimer);
      self._debounceTimer = setTimeout(function () {
        self.getPasswords(1);
      }, 500);
    },

    isExpanded: function (id) {
      return this.expandedItems.indexOf(id) >= 0;
    },

    toggleExpand: function (id) {
      const idx = this.expandedItems.indexOf(id);
      if (idx >= 0) {
        this.expandedItems.splice(idx, 1);
      } else {
        this.expandedItems.push(id);
      }
    },

    toggleExpandAll: function () {
      this.expandAllState = !this.expandAllState;
      this.expandedItems = this.expandAllState
        ? this.groupedPasswords.map((g) => g.atendimento.id)
        : [];
    },

    calcTotalTime: function (etapas) {
      let totalSeconds = 0;
      etapas.forEach((e) => {
        if (e.tempo_total && typeof e.tempo_total === "string") {
          const parts = e.tempo_total.split(":");
          if (parts.length === 3) {
            totalSeconds +=
              parseInt(parts[0]) * 3600 +
              parseInt(parts[1]) * 60 +
              parseInt(parts[2]);
          }
        }
      });
      const h = Math.floor(totalSeconds / 3600)
        .toString()
        .padStart(2, "0");
      const m = Math.floor((totalSeconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const s = (totalSeconds % 60).toString().padStart(2, "0");
      return `${h}:${m}:${s}`;
    },

    // Detecta se a etapa foi encerrada pelo "Fechar dia":
    // status ainda ativo (1 ou 2) mas data_fim preenchida
    isFechamentoDia: function (etapa) {
      return etapa.data_fim && (etapa.status === 1 || etapa.status === 2);
    },

    resolveEtapaText: function (etapa) {
      if (this.isFechamentoDia(etapa)) {
        const nomes = { 1: "Em fila", 2: "Em atendimento" };
        const original = nomes[etapa.status] || etapa.status_text || "";
        return original
          ? `${original} · Encerrado via fechamento de dia`
          : "Encerrado via fechamento de dia";
      }
      return etapa.status_text;
    },

    resolveEtapaColor: function (etapa) {
      return this.isFechamentoDia(etapa)
        ? "warning"
        : this.getEtapaStatusColor(etapa.status);
    },

    getStatusText: function (grupo) {
      const last = grupo.etapas[grupo.etapas.length - 1];
      return this.resolveEtapaText(last);
    },

    getStatusBadgeColor: function (grupo) {
      const last = grupo.etapas[grupo.etapas.length - 1];
      return this.resolveEtapaColor(last);
    },

    getEtapaStatusColor: function (status) {
      const map = {
        0: "warning", // Ausente
        1: "secondary", // Em fila
        2: "primary", // Em atendimento
        3: "success", // Finalizado
        4: "danger", // Evasão
        5: "danger", // Cancelado
        8: "info", // Espera com reavaliação
        9: "info", // Medicação
      };
      return map[status] ?? "secondary";
    },

    getSenhaBadgeStyle: function (grupo) {
      const classificacao = grupo.etapas[0] && grupo.etapas[0].classificacao;
      if (!classificacao || !classificacao.cor) {
        return { backgroundColor: "#17a2b8", color: "#fff" };
      }
      return {
        backgroundColor: classificacao.cor,
        color: this.getContrastColor(classificacao.cor),
      };
    },

    getContrastColor: function (hex) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      // luminância relativa — escuro < 128 → texto branco
      return (r * 299 + g * 587 + b * 114) / 1000 < 128 ? "#fff" : "#212529";
    },

    getSectores: function () {
      const self = this;
      axios
        .get(self.$store.state.api + "setores/?paginate=false")
        .then((response) => {
          self.setores = response.data.data || response.data;
        })
        .catch(() => {});
    },

    getClassificacoes: function () {
      const self = this;
      axios
        .get(self.$store.state.api + "classificacoes/?paginate=false")
        .then((response) => {
          self.classificacoes = response.data.data || response.data;
        })
        .catch(() => {});
    },

    getUsuarios: function () {
      const self = this;
      axios
        .get(self.$store.state.api + "users/?paginate=false")
        .then((response) => {
          self.usuarios = response.data.data || response.data;
        })
        .catch(() => {});
    },

    getPrioridades: function () {
      const self = this;
      axios
        .get(self.$store.state.api + "prioridades/?paginate=false")
        .then((response) => {
          self.prioridades = response.data.data || response.data;
        })
        .catch(() => {});
    },

    onSetorChange: function (nome) {
      this.filtros.setor = nome || "";
    },

    // RN04c/RN04d: valida ordem e obrigatoriedade das datas antes de
    // pesquisar/exportar. Retorna true se válido, ou mostra a mensagem de
    // erro e retorna false.
    validarPeriodo: function () {
      const self = this;

      if (self.pesquisa.data_fim && !self.pesquisa.data_inicio) {
        self.$message(
          null,
          "Preencha a Data Inicial antes de pesquisar ou exportar.",
          "error"
        );
        return false;
      }

      if (
        self.pesquisa.data_inicio &&
        self.pesquisa.data_fim &&
        self.pesquisa.data_inicio > self.pesquisa.data_fim
      ) {
        self.$message(
          null,
          "A Data Inicial não pode ser posterior à Data Final.",
          "error"
        );
        return false;
      }

      return true;
    },

    getPasswords: function (page) {
      const self = this;
      self.page = page || 1;
      const api = self.$store.state.api + "acompanhamento?page=" + self.page;

      self.passwords = [];
      self.expandedItems = [];
      self.expandAllState = false;

      if (self.pesquisa.data_inicio !== "" || self.pesquisa.data_fim !== "") {
        if (!self.validarPeriodo()) {
          return;
        }

        self.$loading(true);

        const payload = {
          prefixo: self.pesquisa.prefixo,
          senha: self.pesquisa.senha,
          data_inicio: self.pesquisa.data_inicio,
          data_fim: self.pesquisa.data_fim,
          pessoa: self.filtros.pessoa,
          demanda: self.filtros.demanda,
          setor: self.filtros.setor,
          local: self.filtros.local,
          status: self.filtros.status,
          operador_id: self.filtros.operadorId,
          grupo_prioritario: self.filtros.grupoPrioritario,
          prioridade_filter: self.filtros.prioridadeFilter,
        };

        axios
          .post(api, payload)
          .then((response) => {
            self.passwords = response.data.data;
            self.total = response.data.total;
            self.$loading(false);
          })
          .catch((error) => {
            self.$loading(false);
            self.$message(null, error.response.data, "error");
          });
      } else {
        self.$message(
          null,
          "Por favor, insira ao menos data inicial ou final",
          "error"
        );
      }
    },

    getPdf: function () {
      const self = this;
      const api = self.$store.state.api + "pdf_acompanha/";

      self.$loading(true);
      axios
        .post(api, self.passwords)
        .then((response) => {
          self.$loading(false);
          self.openPdf(response.data);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    openPdf: function (hash) {
      const self = this;
      window.open(
        `${self.$store.state.url}pdf_acompanhamento?h=${hash}&c=${self.passwords.length}`,
        "_blank"
      );
    },

    getExcel: function () {
      const self = this;

      if (self.excelProcessing) {
        return;
      }

      const api = self.$store.state.api + "excel_acompanha/";

      if (!self.pesquisa.data_inicio && !self.pesquisa.data_fim) {
        self.$message(
          null,
          "Por favor, selecione ao menos uma data para exportar",
          "error"
        );
        return;
      }

      if (!self.validarPeriodo()) {
        return;
      }

      if (self.pesquisa.data_inicio && self.pesquisa.data_fim) {
        const dataInicio = new Date(self.pesquisa.data_inicio);
        const dataFim = new Date(self.pesquisa.data_fim);
        // Contagem inclusiva (mesmo critério do backend: startOfDay até
        // endOfDay), pra não deixar passar no front um período que o
        // backend rejeita — ex: 01/01 a 31/01 são 31 dias corridos, mesmo
        // a diferença em milissegundos batendo exatamente 30 dias.
        const diffDays =
          Math.round((dataFim - dataInicio) / (1000 * 60 * 60 * 24)) + 1;

        if (diffDays > 30) {
          self.$message(
            "Período muito longo",
            `O período máximo para exportação é de 30 dias. Você selecionou ${diffDays} dias.`,
            "error"
          );
          return;
        }
      }

      self.excelProcessing = true;
      self.excelReady = false;
      self.excelFilename = null;

      axios
        .post(api, {
          prefixo: self.pesquisa.prefixo,
          senha: self.pesquisa.senha,
          data_inicio: self.pesquisa.data_inicio,
          data_fim: self.pesquisa.data_fim,
          setor: self.filtros.setor,
          local: self.filtros.local,
          pessoa: self.filtros.pessoa,
          demanda: self.filtros.demanda,
          status: self.filtros.status,
          operador_id: self.filtros.operadorId,
          grupo_prioritario: self.filtros.grupoPrioritario,
          prioridade_filter: self.filtros.prioridadeFilter,
        })
        .then((response) => {
          if (response.data.filename) {
            // Só avisa que a exportação começou depois de confirmar com o
            // backend que o pedido foi aceito — evita mostrar "iniciado"
            // ao mesmo tempo que um erro de validação (ex: período > 30 dias).
            swal(
              "Exportação iniciada",
              "O Excel está sendo gerado em segundo plano com todos os registros do período selecionado. Isso pode levar alguns instantes — você será notificado quando o arquivo estiver pronto para download.",
              "info"
            );

            localStorage.setItem(
              "excelExport",
              JSON.stringify({
                processing: true,
                ready: false,
                filename: response.data.filename,
                timestamp: new Date().getTime(),
              })
            );
            self.checkExcelStatus(response.data.filename);
          } else {
            self.excelProcessing = false;
          }
        })
        .catch((error) => {
          self.excelProcessing = false;
          localStorage.removeItem("excelExport");
          const errorMsg = error.response?.data || "Erro ao iniciar exportação";
          self.$message("Erro na exportação", errorMsg, "error");
        });
    },

    checkExcelStatus: function (filename) {
      const self = this;
      const api = `${self.$store.state.url}check_excel_status?filename=${filename}`;

      if (self.excelCheckInterval) {
        clearInterval(self.excelCheckInterval);
      }
      if (self.excelTimeout) {
        clearTimeout(self.excelTimeout);
      }

      self.excelCheckInterval = setInterval(function () {
        axios
          .get(api)
          .then((response) => {
            if (response.data.ready) {
              clearInterval(self.excelCheckInterval);
              self.excelCheckInterval = null;

              if (self.excelTimeout) {
                clearTimeout(self.excelTimeout);
                self.excelTimeout = null;
              }

              self.excelProcessing = false;
              self.excelReady = true;
              self.excelFilename = response.data.filename;

              localStorage.setItem(
                "excelExport",
                JSON.stringify({
                  processing: false,
                  ready: true,
                  filename: response.data.filename,
                  timestamp: new Date().getTime(),
                })
              );
            }
          })
          .catch((error) => {
            clearInterval(self.excelCheckInterval);
            self.excelCheckInterval = null;

            if (self.excelTimeout) {
              clearTimeout(self.excelTimeout);
              self.excelTimeout = null;
            }

            self.excelProcessing = false;
            self.excelReady = false;
            localStorage.removeItem("excelExport");

            if (error.response?.data?.error) {
              self.$message(
                "Erro ao gerar arquivo",
                error.response.data.message || "O arquivo não pôde ser gerado.",
                "error"
              );
            } else {
              self.$message(
                "Erro ao verificar status",
                "Não foi possível verificar o status do arquivo",
                "error"
              );
            }
          });
      }, 3000);

      self.excelTimeout = setTimeout(function () {
        if (self.excelCheckInterval) {
          clearInterval(self.excelCheckInterval);
          self.excelCheckInterval = null;
        }
        if (self.excelProcessing) {
          self.excelProcessing = false;
          localStorage.removeItem("excelExport");
          self.$message(
            null,
            "Tempo limite excedido. Tente novamente mais tarde.",
            "error"
          );
        }
        self.excelTimeout = null;
      }, 600000);
    },

    downloadExcel: function (filename) {
      const self = this;
      window.open(
        `${self.$store.state.url}excel_acompanhamento?filename=${filename}`,
        "_blank"
      );
      self.excelReady = false;
      self.excelFilename = null;
      localStorage.removeItem("excelExport");
    },

    restoreExcelExportState: function () {
      const self = this;
      const savedState = localStorage.getItem("excelExport");

      if (savedState) {
        try {
          const state = JSON.parse(savedState);
          const elapsed = new Date().getTime() - state.timestamp;

          if (elapsed > 600000) {
            localStorage.removeItem("excelExport");
            return;
          }

          self.excelProcessing = state.processing;
          self.excelReady = state.ready;
          self.excelFilename = state.filename;

          if (state.processing && state.filename) {
            self.checkExcelStatus(state.filename);
          }
        } catch (e) {
          localStorage.removeItem("excelExport");
        }
      }
    },

    getConfiguracao: function () {
      const self = this;
      const api = self.$store.state.api + "configuracoes/";

      axios
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];
          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    setLoader: function (qtd) {
      const self = this;
      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;
        if (load === qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    self.setLoader(50);
    self.getConfiguracao();
    self.getSectores();
    self.getClassificacoes();
    self.getUsuarios();
    self.getPrioridades();
    self.restoreExcelExportState();
  },
  beforeDestroy: function () {
    const self = this;
    if (self.excelCheckInterval) {
      clearInterval(self.excelCheckInterval);
    }
    if (self.excelTimeout) {
      clearTimeout(self.excelTimeout);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Pagination,
  },
};
</script>

<style scoped>
.senha-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
}

.senha-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  gap: 12px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s;
}

.senha-card-header:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  gap: 4px;
}

.header-nome {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
}

.header-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
}

.senha-card-body {
  border-top: 1px solid #dee2e6;
}

.card-data-entrada {
  font-size: 0.88em;
  font-weight: 500;
  color: #495057;
  white-space: nowrap;
}

.card-etapas-badge {
  font-size: 0.8em;
  font-weight: 600;
  color: #495057;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  white-space: nowrap;
}

.chevron-icon {
  color: #6c757d;
  flex-shrink: 0;
}

.empty-state {
  padding: 60px 20px;
  text-align: center;
}

.empty-state-content {
  max-width: 400px;
  margin: 0 auto;
}

.empty-state i {
  opacity: 0.5;
  display: block;
  margin-bottom: 12px;
}

.empty-state h5 {
  margin-bottom: 10px;
  font-weight: 600;
}

.empty-state p {
  font-size: 14px;
}
</style>

<style>
.dark-layout .card-data-entrada {
  color: #b4b7bd !important;
}

.dark-layout .card-etapas-badge {
  background-color: #3b4253 !important;
  border-color: #4a5568 !important;
  color: #d0d2d6 !important;
}

.dark-layout .text-dark {
  color: #d0d2d6 !important;
}
</style>
